export default {
  title: 'Challenge',
  actions: {
    create: 'create a challenge',
    confirmDelete: 'Are you sure you want to delete this challenge?',
    delete: 'Delete',
    cancel: 'Cancel'
  },
  empty: {
    title: 'No challenge',
    message: 'To create a challenge, nothing could be easier, just click on the following link:'
  },
  state: {
    published: 'published',
    testing: 'testing',
    terminated: 'finished'
  },
  modal: {
    informations: 'Information',
    description_1: 'You must enter a name, a description and an image for your challenge. These will be displayed directly to your users and must therefore be meaningful, punchy and as conscriptive as possible.',
    popup: 'Popup',
    description_2: 'If you wish, you can display a popup with a personalized message. These messages will appear at the launch of the challenge and during its progress, and/or at the end of the challenge depending on the final status of the challenge.',
    campaign: 'Campaign',
    description_3: 'A campaign can be linked to a challenge. If the challenge is successful, then the campaign will be unlocked for all users who participated in it.',
    create: {
      title: 'create a challenge',
      fields: {
        name: 'Name',
        period: 'Restrict the period',
        date: {
          start: 'Start',
          end: 'End'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/challenge.js